import { getAuth, onAuthStateChanged } from "@firebase/auth";
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Edit, Phone } from "react-feather";
import { Link } from "react-router-dom";
import { BounceLoader } from "react-spinners";
import ButtonSpinner from "../../Components/Spinners/ButtonSpinner";
import "./Profile.css";
import ProfileViewModal from "./ProfileViewModal";

const Profile = () => {
  const [
    CurrentAuth,
    email,
    setEmail,
    ResetPassword,
    EmailError,
    IsPasswordResetEmailSend,
    ProfileImage,
    setProfileImage,
    refresh,
    ButtonLoader,
  ] = ProfileViewModal();

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
      }
    });
  }, [refresh]);

  console.log("CurrentAuth", CurrentAuth);

  const [Tab, SetTab] = useState(1);
  return (
    <Fragment>
      {CurrentAuth?.UserType === "admin" ? (
        <Fragment>
          <div className="page-wrapper">
            <div className="content container-fluid">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">Profile</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={`/user/${CurrentAuth?.UserType}/dashboard`}>
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Profile</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-header">
                    <div className="row mb-2 align-items-center">
                      {/* <input
                  type="file"
                  id="actual-btn"
                  accept=".jpg, .jpeg, .png"
                  className="custom-file-btn"
                  onChange={(e) => {
                    setProfileImage(e.target.files[0]);
                  }}
                /> */}

                      <div className="col-auto profile-image">
                        {ButtonLoader && (
                          <p className="file-upload-loader">
                            <BounceLoader />
                          </p>
                        )}
                        {!ButtonLoader && (
                          <label className="file-upload profile-upbtn mb-0">
                            {/* <i className="feather-edit-3"></i> */}
                            <div className="profile-image-change-button">
                              <Edit color="white" size={20} />
                            </div>
                            <input
                              type="file"
                              className="profile-change-input"
                              accept=".jpg, .jpeg, .png"
                              onChange={(e) => {
                                setProfileImage(e.target.files[0]);
                              }}
                            />
                          </label>
                        )}

                        <a className="user-img">
                          <img
                            className={` rounded-circle ${
                              ButtonLoader ? "opacity-25" : ""
                            }`}
                            alt="User Image"
                            src={
                              getAuth().currentUser.photoURL
                                ? getAuth().currentUser.photoURL
                                : require("../../Assets/images/profiles/avatar-02.jpg")
                            }
                          />
                        </a>
                      </div>
                      <div className="col ms-md-n2 profile-user-info">
                        <h4 className="user-name mb-0">
                          {CurrentAuth?.FirstName + CurrentAuth?.LastName}
                        </h4>
                        <h6 className="text-muted  text-capitalize">
                          {CurrentAuth?.AdditionalDetails?.Designation}
                        </h6>
                        <div
                          className="user-Location
                   "
                        >
                          {CurrentAuth?.AdditionalDetails?.PhoneNo && (
                            <Phone color="#66676b" />
                          )}
                          &nbsp;
                          {CurrentAuth?.AdditionalDetails?.PhoneNo}
                        </div>
                      </div>
                      <div className="col-auto profile-btn d-none">
                        <a href className="btn btn-primary">
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="profile-menu">
                    <ul className="nav nav-tabs nav-tabs-solid">
                      <li
                        className="nav-item"
                        onClick={() => {
                          SetTab(1);
                        }}
                      >
                        <a
                          className={`nav-link ${Tab === 1 ? "active" : ""}`}
                          data-bs-toggle="tab"
                        >
                          About
                        </a>
                      </li>
                      <li
                        className={`nav-item ${Tab === 2 ? "active" : ""}`}
                        onClick={() => {
                          SetTab(2);
                        }}
                      >
                        <a className="nav-link" data-bs-toggle="tab">
                          Password
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content profile-tab-cont">
                    {/* Personal Details Tab */}
                    {Tab === 1 && (
                      <div
                        className="tab-pane fade show active"
                        id="per_details_tab"
                      >
                        {/* Personal Details */}
                        <div className="row">
                          <div className="col-lg-9">
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between mb-2">
                                  <span>Personal Details</span>
                                  <a
                                    className="edit-link d-none"
                                    data-bs-toggle="modal"
                                    href="#edit_personal_details"
                                  >
                                    <i className="far fa-edit me-1" />
                                    Edit
                                  </a>
                                </h5>
                                <div className="row">
                                  <p
                                    className="col-sm-3 text-muted  mb-0 mb-sm-3
                              personal-details-item
                            "
                                  >
                                    Name
                                  </p>
                                  <p className="col-sm-9 text-capitalize">
                                    {" "}
                                    {CurrentAuth?.FirstName +
                                      " " +
                                      CurrentAuth?.LastName}
                                  </p>
                                </div>
                                <div className="row">
                                  <p
                                    className="col-sm-3 text-muted  mb-0 mb-sm-3 
                              personal-details-item
                            "
                                  >
                                    Gender
                                  </p>
                                  <p className="col-sm-9 text-capitalize">
                                    {" "}
                                    {CurrentAuth?.Gender}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-3 text-muted  mb-0 mb-sm-3 personal-details-item">
                                    Email ID
                                  </p>
                                  <p className="col-sm-9">
                                    {" "}
                                    {CurrentAuth?.Email}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-3 text-muted  mb-0 mb-sm-3 personal-details-item">
                                    Mobile
                                  </p>
                                  <p className="col-sm-9">
                                    {" "}
                                    {CurrentAuth?.AdditionalDetails?.PhoneNo}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-3 text-muted  mb-0 personal-details-item">
                                    School Address
                                  </p>
                                  <p
                                    className="col-sm-9 mb-0 
                            text-capitalize
                          "
                                  >
                                    {
                                      CurrentAuth?.AdditionalDetails
                                        ?.SchoolAddress
                                    }
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            {/* Account Status */}
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between">
                                  <span>Account Status</span>
                                  <a className="edit-link edit d-none" href="#">
                                    <i className="far fa-edit me-1" /> Edit
                                  </a>
                                </h5>
                                <button
                                  className="btn btn-success"
                                  type="button"
                                >
                                  <i className="fe fe-check-verified" /> Active
                                </button>
                              </div>
                            </div>
                            {/* /Account Status */}
                            {/* Skills */}
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between">
                                  <span>Subjects </span>
                                  <a className="edit-link d-none" href="#">
                                    <i className="far fa-edit me-1" /> Edit
                                  </a>
                                </h5>
                                <div className="skill-tags">
                                  <span>Maths</span>
                                  <span>Physic</span>
                                  <span>English</span>
                                  <span>Urdu</span>
                                </div>
                              </div>
                            </div>
                            {/* /Skills */}
                          </div>
                        </div>
                        {/* /Personal Details */}
                      </div>
                    )}

                    {/* /Personal Details Tab */}
                    {/* Change Password Tab */}
                    {Tab === 2 && (
                      <div id="password_tab" className="fade show active">
                        <div className="card">
                          <div className="card-body">
                            <h5 className="card-title">Change Password</h5>
                            <div className="row">
                              <div className="col-md-10 col-lg-6">
                                <form className="change-password-form">
                                  <p>
                                    Enter your register email to get a password
                                    change link.
                                  </p>

                                  <div className="form-group">
                                    <label>
                                      Email{" "}
                                      <span className="login-danger">*</span>
                                    </label>
                                    <input
                                      className={`form-control ${
                                        EmailError === true && "error-message"
                                      }`}
                                      type="email"
                                      value={email}
                                      onChange={(e) => {
                                        setEmail(e.target.value);
                                      }}
                                    />

                                    {EmailError === true ? (
                                      <span className="login-tooltip">
                                        <i className="fa-solid fa-info icon-after-submit"></i>
                                        <span className="text-after-submit">
                                          Email is required. xyz@gmail.com
                                        </span>
                                      </span>
                                    ) : (
                                      <span className="login-tooltip">
                                        <i className="fa-solid fa-info text-info"></i>
                                        <span className="login-tooltip-text">
                                          Email is required. xyz@gmail.com
                                        </span>
                                      </span>
                                    )}
                                  </div>
                                  {IsPasswordResetEmailSend && (
                                    <p>
                                      Password change link is send to your
                                      email.check your email to change password.
                                    </p>
                                  )}
                                  <button
                                    className="btn btn-primary"
                                    type="submit"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      ResetPassword();
                                    }}
                                  >
                                    {IsPasswordResetEmailSend
                                      ? "Resend"
                                      : " Send link"}
                                  </button>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* /Change Password Tab */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      ) : CurrentAuth?.UserType === "teacher" ? (
        <Fragment>
          <div className="page-wrapper">
            <div className="content container-fluid">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">Profile</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={`/user/${CurrentAuth?.UserType}/dashboard`}>
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Profile</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-header">
                    <div className="row mb-2 align-items-center">
                      <div className="col-auto profile-image">
                        {ButtonLoader && (
                          <p className="file-upload-loader">
                            <BounceLoader />
                          </p>
                        )}
                        {!ButtonLoader && (
                          <label className="file-upload profile-upbtn mb-0">
                            {/* <i className="feather-edit-3"></i> */}
                            <div className="profile-image-change-button">
                              <Edit color="white" size={20} />
                            </div>
                            <input
                              type="file"
                              className="profile-change-input"
                              accept=".jpg, .jpeg, .png"
                              onChange={(e) => {
                                setProfileImage(e.target.files[0]);
                              }}
                            />
                          </label>
                        )}

                        <a className="user-img">
                          <img
                            className={` rounded-circle ${
                              ButtonLoader ? "opacity-25" : ""
                            }`}
                            alt="User Image"
                            src={
                              getAuth().currentUser.photoURL
                                ? getAuth().currentUser.photoURL
                                : require("../../Assets/images/profiles/avatar-02.jpg")
                            }
                          />
                        </a>
                      </div>
                      <div className="col ms-md-n2 profile-user-info">
                        <h4 className="user-name mb-0">
                          {CurrentAuth?.FirstName + CurrentAuth?.LastName}
                        </h4>
                        <h6 className="text-muted  text-capitalize">
                          {CurrentAuth?.AdditionalDetails?.Designation}
                        </h6>
                        <div className="user-Location">
                          {CurrentAuth?.AdditionalDetails?.PhoneNo && (
                            <Phone color="#66676b" />
                          )}
                          &nbsp;
                          {CurrentAuth?.AdditionalDetails?.PhoneNo}
                        </div>
                      </div>
                      <div className="col-auto profile-btn d-none">
                        <a href className="btn btn-primary">
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="profile-menu">
                    <ul className="nav nav-tabs nav-tabs-solid">
                      <li
                        className="nav-item"
                        onClick={() => {
                          SetTab(1);
                        }}
                      >
                        <a
                          className={`nav-link ${Tab === 1 ? "active" : ""}`}
                          data-bs-toggle="tab"
                        >
                          About
                        </a>
                      </li>
                      <li
                        className={`nav-item ${Tab === 2 ? "active" : ""}`}
                        onClick={() => {
                          SetTab(2);
                        }}
                      >
                        <a className="nav-link" data-bs-toggle="tab">
                          Password
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content profile-tab-cont">
                    {/* Personal Details Tab */}
                    {Tab === 1 && (
                      <div
                        className="tab-pane fade show active"
                        id="per_details_tab"
                      >
                        {/* Personal Details */}
                        <div className="row">
                          <div className="col-lg-9">
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between mb-2">
                                  <span>Personal Details</span>
                                  <a
                                    className="edit-link d-none"
                                    data-bs-toggle="modal"
                                    href="#edit_personal_details"
                                  >
                                    <i className="far fa-edit me-1" />
                                    Edit
                                  </a>
                                </h5>
                                <div className="row">
                                  <p className="col-sm-3 text-muted mb-0 mb-sm-3 personal-details-item">
                                    Name
                                  </p>
                                  <p className="col-sm-9 text-capitalize">
                                    {" "}
                                    {CurrentAuth?.FirstName +
                                      " " +
                                      CurrentAuth?.LastName}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-3 text-muted  mb-0 mb-sm-3 personal-details-item">
                                    Gender
                                  </p>
                                  <p className="col-sm-9 text-capitalize">
                                    {" "}
                                    {CurrentAuth?.Gender}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-3 text-muted mb-0 mb-sm-3 personal-details-item">
                                    Email ID
                                  </p>
                                  <p className="col-sm-9">
                                    {" "}
                                    {CurrentAuth?.Email}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            {/* Account Status */}
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between">
                                  <span>Account Status</span>
                                </h5>
                                {CurrentAuth?.IsVerified === 0 ? (
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                  >
                                    Pending
                                  </button>
                                ) : CurrentAuth?.IsVerified === 1 ? (
                                  <button
                                    className="btn btn-success"
                                    type="button"
                                  >
                                    Active
                                  </button>
                                ) : CurrentAuth?.IsVerified === 2 ? (
                                  <button
                                    className="btn btn-danger"
                                    type="button"
                                  >
                                    Rejected
                                  </button>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            {/* /Account Status */}
                            {/* Skills */}
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between">
                                  <span>Subjects </span>
                                </h5>
                                <div className="skill-tags">
                                  <span>Maths</span>
                                  <span>Physic</span>
                                  <span>English</span>
                                  <span>Urdu</span>
                                </div>
                              </div>
                            </div>
                            {/* /Skills */}
                          </div>
                        </div>
                        {/* /Personal Details */}
                      </div>
                    )}

                    {/* /Personal Details Tab */}
                    {/* Change Password Tab */}
                    {Tab === 2 && (
                      <div id="password_tab" className="fade show active">
                        <div className="card">
                          <div className="card-body">
                            <h5 className="card-title">Change Password</h5>
                            <div className="row">
                              <div className="col-md-10 col-lg-6">
                                <form className="change-password-form">
                                  <p>
                                    Enter your register email to get a password
                                    change link.
                                  </p>

                                  <div className="form-group">
                                    <label>
                                      Email{" "}
                                      <span className="login-danger">*</span>
                                    </label>
                                    <input
                                      className={`form-control ${
                                        EmailError === true && "error-message"
                                      }`}
                                      type="email"
                                      value={email}
                                      onChange={(e) => {
                                        setEmail(e.target.value);
                                      }}
                                    />

                                    {EmailError === true ? (
                                      <span className="login-tooltip">
                                        <i className="fa-solid fa-info icon-after-submit"></i>
                                        <span className="text-after-submit">
                                          Email is required. xyz@gmail.com
                                        </span>
                                      </span>
                                    ) : (
                                      <span className="login-tooltip">
                                        <i className="fa-solid fa-info text-info"></i>
                                        <span className="login-tooltip-text">
                                          Email is required. xyz@gmail.com
                                        </span>
                                      </span>
                                    )}
                                  </div>
                                  {IsPasswordResetEmailSend && (
                                    <p>
                                      Password change link is send to your
                                      email.check your email to change password.
                                    </p>
                                  )}
                                  <button
                                    className="btn btn-primary"
                                    type="submit"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      ResetPassword();
                                    }}
                                  >
                                    {IsPasswordResetEmailSend
                                      ? "Resend"
                                      : " Send link"}
                                  </button>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* /Change Password Tab */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      ) : CurrentAuth?.UserType === "student" ? (
        <Fragment>
          <div className="page-wrapper">
            <div className="content container-fluid">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">Profile</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={`/user/${CurrentAuth?.UserType}/dashboard`}>
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Profile</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-header">
                    <div className="row mb-2 align-items-center">
                      <div className="col-auto profile-image">
                        {ButtonLoader && (
                          <p className="file-upload-loader">
                            <BounceLoader />
                          </p>
                        )}
                        {!ButtonLoader && (
                          <label className="file-upload profile-upbtn mb-0">
                            {/* <i className="feather-edit-3"></i> */}
                            <div className="profile-image-change-button">
                              <Edit color="white" size={20} />
                            </div>
                            <input
                              type="file"
                              className="profile-change-input"
                              accept=".jpg, .jpeg, .png"
                              onChange={(e) => {
                                setProfileImage(e.target.files[0]);
                              }}
                            />
                          </label>
                        )}

                        <a className="user-img">
                          <img
                            className={` rounded-circle ${
                              ButtonLoader ? "opacity-25" : ""
                            }`}
                            alt="User Image"
                            src={
                              getAuth().currentUser.photoURL
                                ? getAuth().currentUser.photoURL
                                : require("../../Assets/images/profiles/avatar-02.jpg")
                            }
                          />
                        </a>
                      </div>
                      <div className="col ms-md-n2 profile-user-info">
                        <h4 className="user-name mb-0">
                          {CurrentAuth?.FirstName + CurrentAuth?.LastName}
                        </h4>
                        <h6 className="text-muted  text-capitalize">
                          {CurrentAuth?.AdditionalDetails?.Designation}
                        </h6>
                        <div className="user-Location">
                          {CurrentAuth?.AdditionalDetails?.PhoneNo && (
                            <Phone color="#66676b" />
                          )}
                          &nbsp;
                          {CurrentAuth?.AdditionalDetails?.PhoneNo}
                        </div>
                      </div>
                      <div className="col-auto profile-btn d-none">
                        <a href className="btn btn-primary">
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="profile-menu">
                    <ul className="nav nav-tabs nav-tabs-solid">
                      <li
                        className="nav-item"
                        onClick={() => {
                          SetTab(1);
                        }}
                      >
                        <a
                          className={`nav-link ${Tab === 1 ? "active" : ""}`}
                          data-bs-toggle="tab"
                        >
                          About
                        </a>
                      </li>
                      <li
                        className={`nav-item ${Tab === 2 ? "active" : ""}`}
                        onClick={() => {
                          SetTab(2);
                        }}
                      >
                        <a className="nav-link" data-bs-toggle="tab">
                          Password
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content profile-tab-cont">
                    {/* Personal Details Tab */}
                    {Tab === 1 && (
                      <div
                        className="tab-pane fade show active"
                        id="per_details_tab"
                      >
                        {/* Personal Details */}
                        <div className="row">
                          <div className="col-lg-9">
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between mb-2">
                                  <span>Personal Details</span>
                                  <a
                                    className="edit-link d-none"
                                    data-bs-toggle="modal"
                                    href="#edit_personal_details"
                                  >
                                    <i className="far fa-edit me-1" />
                                    Edit
                                  </a>
                                </h5>
                                <div className="row">
                                  <p className="col-sm-3 text-muted mb-0 mb-sm-3 personal-details-item">
                                    Name
                                  </p>
                                  <p className="col-sm-9 text-capitalize">
                                    {" "}
                                    {CurrentAuth?.FirstName +
                                      " " +
                                      CurrentAuth?.LastName}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-3 text-muted  mb-0 mb-sm-3 personal-details-item">
                                    Gender
                                  </p>
                                  <p className="col-sm-9 text-capitalize">
                                    {" "}
                                    {CurrentAuth?.Gender}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-3 text-muted mb-0 mb-sm-3 personal-details-item">
                                    Email ID
                                  </p>
                                  <p className="col-sm-9">
                                    {" "}
                                    {CurrentAuth?.Email}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            {/* Account Status */}
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between">
                                  <span>Account Status</span>
                                </h5>
                                {CurrentAuth?.IsVerified === 0 ? (
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                  >
                                    Pending
                                  </button>
                                ) : CurrentAuth?.IsVerified === 1 ? (
                                  <button
                                    className="btn btn-success"
                                    type="button"
                                  >
                                    Active
                                  </button>
                                ) : CurrentAuth?.IsVerified === 2 ? (
                                  <button
                                    className="btn btn-danger"
                                    type="button"
                                  >
                                    Rejected
                                  </button>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            {/* /Account Status */}
                            {/* Skills */}
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between">
                                  <span>Subjects </span>
                                </h5>
                                <div className="skill-tags">
                                  <span>Maths</span>
                                  <span>Physic</span>
                                  <span>English</span>
                                  <span>Urdu</span>
                                </div>
                              </div>
                            </div>
                            {/* /Skills */}
                          </div>
                        </div>
                        {/* /Personal Details */}
                      </div>
                    )}

                    {/* /Personal Details Tab */}
                    {/* Change Password Tab */}
                    {Tab === 2 && (
                      <div id="password_tab" className="fade show active">
                        <div className="card">
                          <div className="card-body">
                            <h5 className="card-title">Change Password</h5>
                            <div className="row">
                              <div className="col-md-10 col-lg-6">
                                <form className="change-password-form">
                                  <p>
                                    Enter your register email to get a password
                                    change link.
                                  </p>

                                  <div className="form-group">
                                    <label>
                                      Email{" "}
                                      <span className="login-danger">*</span>
                                    </label>
                                    <input
                                      className={`form-control ${
                                        EmailError === true && "error-message"
                                      }`}
                                      type="email"
                                      value={email}
                                      onChange={(e) => {
                                        setEmail(e.target.value);
                                      }}
                                    />

                                    {EmailError === true ? (
                                      <span className="login-tooltip">
                                        <i className="fa-solid fa-info icon-after-submit"></i>
                                        <span className="text-after-submit">
                                          Email is required. xyz@gmail.com
                                        </span>
                                      </span>
                                    ) : (
                                      <span className="login-tooltip">
                                        <i className="fa-solid fa-info text-info"></i>
                                        <span className="login-tooltip-text">
                                          Email is required. xyz@gmail.com
                                        </span>
                                      </span>
                                    )}
                                  </div>
                                  {IsPasswordResetEmailSend && (
                                    <p>
                                      Password change link is send to your
                                      email.check your email to change password.
                                    </p>
                                  )}
                                  <button
                                    className="btn btn-primary"
                                    type="submit"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      ResetPassword();
                                    }}
                                  >
                                    {IsPasswordResetEmailSend
                                      ? "Resend"
                                      : " Send link"}
                                  </button>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* /Change Password Tab */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      ) : CurrentAuth?.UserType === "parent" ? (
        <Fragment>
          <div className="page-wrapper">
            <div className="content container-fluid">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">Profile</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={`/user/${CurrentAuth?.UserType}/dashboard`}>
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Profile</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-header">
                    <div className="row mb-2 align-items-center">
                      <div className="col-auto profile-image">
                        {ButtonLoader && (
                          <p className="file-upload-loader">
                            <BounceLoader />
                          </p>
                        )}
                        {!ButtonLoader && (
                          <label className="file-upload profile-upbtn mb-0">
                            {/* <i className="feather-edit-3"></i> */}
                            <div className="profile-image-change-button">
                              <Edit color="white" size={20} />
                            </div>
                            <input
                              type="file"
                              className="profile-change-input"
                              accept=".jpg, .jpeg, .png"
                              onChange={(e) => {
                                setProfileImage(e.target.files[0]);
                              }}
                            />
                          </label>
                        )}

                        <a className="user-img">
                          <img
                            className={` rounded-circle ${
                              ButtonLoader ? "opacity-25" : ""
                            }`}
                            alt="User Image"
                            src={
                              getAuth().currentUser.photoURL
                                ? getAuth().currentUser.photoURL
                                : require("../../Assets/images/profiles/avatar-02.jpg")
                            }
                          />
                        </a>
                      </div>
                      <div className="col ms-md-n2 profile-user-info">
                        <h4 className="user-name mb-0">
                          {CurrentAuth?.FirstName + CurrentAuth?.LastName}
                        </h4>
                        <h6 className="text-muted  text-capitalize">
                          {CurrentAuth?.AdditionalDetails?.Designation}
                        </h6>
                        <div className="user-Location">
                          {CurrentAuth?.AdditionalDetails?.PhoneNo && (
                            <Phone color="#66676b" />
                          )}
                          &nbsp;
                          {CurrentAuth?.AdditionalDetails?.PhoneNo}
                        </div>
                      </div>
                      <div className="col-auto profile-btn d-none">
                        <a href className="btn btn-primary">
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="profile-menu">
                    <ul className="nav nav-tabs nav-tabs-solid">
                      <li
                        className="nav-item"
                        onClick={() => {
                          SetTab(1);
                        }}
                      >
                        <a
                          className={`nav-link ${Tab === 1 ? "active" : ""}`}
                          data-bs-toggle="tab"
                        >
                          About
                        </a>
                      </li>
                      <li
                        className={`nav-item ${Tab === 2 ? "active" : ""}`}
                        onClick={() => {
                          SetTab(2);
                        }}
                      >
                        <a className="nav-link" data-bs-toggle="tab">
                          Password
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content profile-tab-cont">
                    {/* Personal Details Tab */}
                    {Tab === 1 && (
                      <div
                        className="tab-pane fade show active"
                        id="per_details_tab"
                      >
                        {/* Personal Details */}
                        <div className="row">
                          <div className="col-lg-9">
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between mb-2">
                                  <span>Personal Details</span>
                                  <a
                                    className="edit-link d-none"
                                    data-bs-toggle="modal"
                                    href="#edit_personal_details"
                                  >
                                    <i className="far fa-edit me-1" />
                                    Edit
                                  </a>
                                </h5>
                                <div className="row">
                                  <p className="col-sm-3 text-muted mb-0 mb-sm-3 personal-details-item">
                                    Name
                                  </p>
                                  <p className="col-sm-9 text-capitalize">
                                    {" "}
                                    {CurrentAuth?.FirstName +
                                      " " +
                                      CurrentAuth?.LastName}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-3 text-muted  mb-0 mb-sm-3 personal-details-item">
                                    Gender
                                  </p>
                                  <p className="col-sm-9 text-capitalize">
                                    {" "}
                                    {CurrentAuth?.Gender}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-3 text-muted mb-0 mb-sm-3 personal-details-item">
                                    Email ID
                                  </p>
                                  <p className="col-sm-9">
                                    {" "}
                                    {CurrentAuth?.Email}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            {/* Account Status */}
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between">
                                  <span>Account Status</span>
                                </h5>
                                {CurrentAuth?.IsVerified === 0 ? (
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                  >
                                    Pending
                                  </button>
                                ) : CurrentAuth?.IsVerified === 1 ? (
                                  <button
                                    className="btn btn-success"
                                    type="button"
                                  >
                                    Active
                                  </button>
                                ) : CurrentAuth?.IsVerified === 2 ? (
                                  <button
                                    className="btn btn-danger"
                                    type="button"
                                  >
                                    Rejected
                                  </button>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            {/* /Account Status */}
                          </div>
                        </div>
                        {/* /Personal Details */}
                      </div>
                    )}

                    {/* /Personal Details Tab */}
                    {/* Change Password Tab */}
                    {Tab === 2 && (
                      <div id="password_tab" className="fade show active">
                        <div className="card">
                          <div className="card-body">
                            <h5 className="card-title">Change Password</h5>
                            <div className="row">
                              <div className="col-md-10 col-lg-6">
                                <form className="change-password-form">
                                  <p>
                                    Enter your register email to get a password
                                    change link.
                                  </p>

                                  <div className="form-group">
                                    <label>
                                      Email{" "}
                                      <span className="login-danger">*</span>
                                    </label>
                                    <input
                                      className={`form-control ${
                                        EmailError === true && "error-message"
                                      }`}
                                      type="email"
                                      value={email}
                                      onChange={(e) => {
                                        setEmail(e.target.value);
                                      }}
                                    />

                                    {EmailError === true ? (
                                      <span className="login-tooltip">
                                        <i className="fa-solid fa-info icon-after-submit"></i>
                                        <span className="text-after-submit">
                                          Email is required. xyz@gmail.com
                                        </span>
                                      </span>
                                    ) : (
                                      <span className="login-tooltip">
                                        <i className="fa-solid fa-info text-info"></i>
                                        <span className="login-tooltip-text">
                                          Email is required. xyz@gmail.com
                                        </span>
                                      </span>
                                    )}
                                  </div>
                                  {IsPasswordResetEmailSend && (
                                    <p>
                                      Password change link is send to your
                                      email.check your email to change password.
                                    </p>
                                  )}
                                  <button
                                    className="btn btn-primary"
                                    type="submit"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      ResetPassword();
                                    }}
                                  >
                                    {IsPasswordResetEmailSend
                                      ? "Resend"
                                      : " Send link"}
                                  </button>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* /Change Password Tab */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default Profile;
